/*
 *
 * SearchForm
 *
 */

import { strapiPost } from "@/services/user-admin/api";
import { UploadOutlined } from "@ant-design/icons";
import { Button, Image, Upload, message } from "antd";
const CustomImageUpload = ({
  value = "",
  uploadUrl,
  changeImageBtnText,
  optType,
  onChange,
  onLoadingState,
  rawdata,
}: any) => {
  const [messageApi, contextHolder] = message.useMessage();
  const triggerChange = (changedValue: any) => {
    if (onChange) {
      onChange(changedValue);
    }
  };

  const handleBeforeUpload = async (file: any, key: any) => {
    console.log(file, "file-start");
    if (onLoadingState) onLoadingState(true);
    const fileType: any = file.name.substring(file.name.lastIndexOf(".") + 1);
    const fileTypes: any = ["jpg", "jpeg", "png", "webapp", "svg"];
    console.log(fileType, "fileType");
    if (!fileTypes.includes(fileType.toLowerCase())) {
      messageApi.error("You can only upload filetype:" + fileTypes.join(","));
    }
    const isLt2M: any = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      messageApi.error("Image must smaller than 2MB!");
    }
    console.log(file, "file");
    var formData = new FormData();
    formData.append("file", file);
    const resData: any = await strapiPost(
      uploadUrl || "/uploadGameResource",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    if (resData.code === 0) {
      triggerChange(resData.data);
      console.log(resData, "data-uploadGameResource");
    } else {
      messageApi.error(resData.msg);
    }
    // multipart/form-data
    setTimeout(() => {
      if (onLoadingState) onLoadingState(false);
    }, 2000);

    return false;
  };

  // return <Input value={value} onChange={(e) => triggerChange(e.target.value)} />;
  return (
    <>
      {contextHolder}
      {["Edit", "Add"].includes(optType) ? (
        <Upload
          beforeUpload={(event) =>
            handleBeforeUpload(event, rawdata?.dataIndex)
          }
          showUploadList={false}
        >
          <Button icon={<UploadOutlined />}>
            {changeImageBtnText || "Upload Image"}
          </Button>
        </Upload>
      ) : (
        ""
      )}
      {value ? (
        <div style={{ maxWidth: rawdata?.maxWidth }}>
          <Image
            style={{ marginTop: "5px" }}
            width={"100%"}
            src={typeof value === "string" ? value : value.host + value.uri}
          />
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default CustomImageUpload;
